import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TarlV3JsonapiModule } from '®shared/tarl-v3-jsonapi';

import { TenantGuard } from './tenant-guard.service';
import { TenantService } from './tenant.service';

@NgModule({
  imports: [CommonModule, TarlV3JsonapiModule],
  providers: [TenantGuard, TenantService],
})
export class TenantModule {}
